import { render, staticRenderFns } from "./videoplay.vue?vue&type=template&id=70d8a5dd&scoped=true&"
import script from "./videoplay.vue?vue&type=script&lang=js&"
export * from "./videoplay.vue?vue&type=script&lang=js&"
import style0 from "./videoplay.vue?vue&type=style&index=0&id=70d8a5dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8a5dd",
  null
  
)

export default component.exports